import React from "react";
import { Link } from "react-router-dom";
import "./ProductCard.css";
import { FaMapMarkerAlt } from "react-icons/fa";

// Hàm tiện ích để định dạng tiền
const formatPriceVND = (price) => {
  if (!price) return "Thỏa thuận";
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(price);
};

// Hàm tiện ích để lấy Quận/Huyện từ địa chỉ dài
const getDistrict = (address) => {
  if (!address) return "Không rõ";
  const parts = address.split(",").map((part) => part.trim());
  // Thường thì Quận/Huyện sẽ ở vị trí thứ 2 từ cuối lên
  if (parts.length >= 2) {
    return parts[parts.length - 2];
  }
  return address; // Trả về địa chỉ gốc nếu không parse được
};

const ProductCard = ({ product }) => {
  // API có thể trả về ảnh dạng mảng (danh_sach_anh) hoặc string (Thumbnail)
  let productImage =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect width='300' height='200' fill='%23334155'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2394a3b8' font-family='Arial' font-size='16'%3EKhông có ảnh%3C/text%3E%3C/svg%3E";

  if (
    product.danh_sach_anh &&
    Array.isArray(product.danh_sach_anh) &&
    product.danh_sach_anh.length > 0
  ) {
    productImage = product.danh_sach_anh[0];
  } else if (product.Thumbnail) {
    // Thumbnail có thể chứa nhiều URL cách nhau bởi " | ", lấy URL đầu tiên
    const thumbnailUrls = product.Thumbnail.split("|").map((url) => url.trim());
    productImage = thumbnailUrls[0];
  } else if (product.avatar_link) {
    productImage = product.avatar_link;
  } else if (product.image) {
    productImage = product.image;
  }
  const title =
    product.Title ||
    product.title ||
    product.Name ||
    product.name ||
    "(Không có tiêu đề)";
  const price =
    product.Price || product.price || product.amount || product.cost;
  const address =
    product.Address || product.address || product.location || product.city;
  const productID = product.ListingID || product.id || product.ID;

  return (
    <Link to={`/market/detail/${productID}`} className="product-card-link">
      <div className="product-card-container">
        <div className="product-image-wrapper">
          <img
            src={productImage}
            alt={title}
            className="product-main-image"
            onError={(e) => {
              // Tránh infinite loop: chỉ set fallback 1 lần
              if (!e.target.dataset.fallback) {
                e.target.dataset.fallback = "true";
                // Dùng data URL thay vì external URL để tránh bị block
                e.target.src =
                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect width='300' height='200' fill='%23334155'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%2394a3b8' font-family='Arial' font-size='16'%3EKhông có ảnh%3C/text%3E%3C/svg%3E";
              }
            }}
          />
        </div>
        <div className="product-info-wrapper">
          <h3 className="product-title-text">{title}</h3>
          <div className="product-meta">
            {/* API không có, ta thêm tạm */}
            <span>Tình trạng • Mới</span>
          </div>
          <p className="product-price-text">{formatPriceVND(price)}</p>
          <div className="product-location-wrapper">
            <FaMapMarkerAlt className="location-icon" />
            <span>{getDistrict(address)}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
